import ToastOverlayImpl from './toast-overlay.jsx';
import MojitoCore from 'mojito/core';

const UIView = MojitoCore.Presentation.UIView;

/**
 * ToastOverlay module to render toast components that
 * should be displayed on top of application content.
 *
 * @class ToastOverlay
 * @memberof Mojito.Applications.Sports.AppOverlay
 */

export default UIView('ToastOverlay', ToastOverlayImpl);
